import React from 'react';
import { useMyGustoData } from '../../hooks';
import { GustoInfoCard } from './GustoInfoCard';

/**
 * MyGustoInfoCard
 * Container that fetches the current user's own Gusto data and renders it with
 * the shared GustoInfoCard. Kept as a thin wrapper so the self-profile page and
 * its tests keep their stable `my-gusto-info-*` test ids.
 */
export const MyGustoInfoCard: React.FC = () => {
  const { data, isLoading, error } = useMyGustoData();

  return (
    <GustoInfoCard
      data={data}
      isLoading={isLoading}
      error={error}
      testIdPrefix="my-gusto-info"
      descriptionKey="detail.gusto.description"
      notConnectedDescriptionKey="detail.gusto.notConnectedDescription"
    />
  );
};
